// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:1200px){.testimonials .agile--no-nav-buttons .agile__actions{justify-content:flex-end}}.testimonials .agile--no-nav-buttons .agile__actions .agile__dot button{background-color:#535353;width:30px;height:7px;border-radius:4px;border:none;margin:0 2.5px}.testimonials .agile--no-nav-buttons .agile__actions .agile__dot.agile__dot--current button{background-color:#e53646}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
